import './dokumente.css';
import '../briefe/briefe.css';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { BriefeLevel } from '../briefe/BriefeRoutes';
import { useClientApp } from '../context';
import { BwaSheetHost } from '../guv/BwaSheet';
import { DokSheetHost } from './DokSheet';
import { docsFolderOfSlug, dokumentePath } from './labels';
import { FirmsPage, FolderPage, OverviewPage } from './Pages';

// Alle Seiten unter /app/dokumente: Firma → Ordner der Firma → Ordner (Briefe: → Absender).
export function DokumenteRoutes() {
  return (
    <Routes>
      <Route index element={<FirmsPage />} />
      <Route path=":clientId" element={<Level />} />
      <Route path=":clientId/briefe" element={<BriefeLevel />} />
      <Route path=":clientId/briefe/:sender" element={<BriefeLevel folder />} />
      <Route path=":clientId/:folder" element={<Level folder />} />
      <Route path="*" element={<Navigate to={dokumentePath()} replace />} />
    </Routes>
  );
}

// Prüft die Teile der Adresse und zeigt die passende Seite
function Level({ folder }: { folder?: boolean }) {
  const { clients } = useClientApp();
  const p = useParams();
  const clientId = p.clientId ?? '';
  if (!clients.some((c) => c.id === clientId)) return <Navigate to={dokumentePath()} replace />;
  if (folder) {
    const f = docsFolderOfSlug(p.folder);
    if (!f) return <Navigate to={dokumentePath(clientId)} replace />;
    return (
      <>
        <FolderPage clientId={clientId} folder={f} />
        <DokSheetHost />
        <BwaSheetHost />
      </>
    );
  }
  return <OverviewPage clientId={clientId} />;
}
